import { create } from 'zustand'

interface UIState {
  isOnline: boolean
  language: 'es' | 'en'
  isKeyboardVisible: boolean
  setOnline: (online: boolean) => void
  setLanguage: (lang: 'es' | 'en') => void
  setKeyboardVisible: (visible: boolean) => void
  reset: () => void
}

const INITIAL_STATE = {
  isOnline: true,
  language: 'es' as const,
  isKeyboardVisible: false,
}

export const useUIStore = create<UIState>((set) => ({
  ...INITIAL_STATE,
  setOnline: (isOnline) => set({ isOnline }),
  setLanguage: (language) => set({ language }),
  setKeyboardVisible: (isKeyboardVisible) => set({ isKeyboardVisible }),
  reset: () => set(INITIAL_STATE),
}))
